export default "__VITE_ASSET__CuqTvbwl__"